import React from "react";

const defaultregulatoryData = [
  {
    lawViolated: "",
    nonComplianceDetails: "",
    penaltiesTaken: "",
    correctiveAction: "",
  },
];

const RegulatoryNonComplianceTable = ({
  nonComplianceData,
  setNonComplianceData,
}) => {
  const handleChange = (index, field, value) => {
    const updated = [...nonComplianceData];
    updated[index][field] = value;
    setNonComplianceData(updated);
  };

  const addRow = () => {
    setNonComplianceData([
      ...nonComplianceData,
      {
        lawViolated: "",
        nonComplianceDetails: "",
        penaltiesTaken: "",
        correctiveAction: "",
      },
    ]);
  };

  const removeRow = () => {
    if (nonComplianceData.length > 1) {
      setNonComplianceData(nonComplianceData.slice(0, -1));
    }
  };

  return (
    <div
      style={{
        overflowX: "auto",
        marginTop: 20,
        border: "1px solid #000",
        overflow: "hidden",
        borderRadius: "8px",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#d8cbd4" }}>
            <th style={headerCell}>S. No</th>
            <th style={headerCell}>
              Specify the law / regulation / guidelines which was not complied
              with
            </th>
            <th style={headerCell}>Provide details of the non-compliance</th>
            <th style={headerCell}>
              Any fines/penalties/action taken by regulatory agencies such as
              pollution control boards or by courts
            </th>
            <th style={headerCell}>Corrective action taken, if any</th>
          </tr>
        </thead>
        <tbody>
          {nonComplianceData.map((row, index) => (
            <tr key={index}>
              <td style={cell}>{index + 1}.</td>
              <td style={cell}>
                <input
                  type="text"
                  placeholder="Details"
                  value={row.lawViolated}
                  onChange={(e) =>
                    handleChange(index, "lawViolated", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
              <td style={cell}>
                <input
                  type="text"
                  placeholder="Details"
                  value={row.nonComplianceDetails}
                  onChange={(e) =>
                    handleChange(index, "nonComplianceDetails", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
              <td style={cell}>
                <input
                  type="text"
                  placeholder="Details"
                  value={row.penaltiesTaken}
                  onChange={(e) =>
                    handleChange(index, "penaltiesTaken", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
              <td style={cell}>
                <input
                  type="text"
                  placeholder="Details"
                  value={row.correctiveAction}
                  onChange={(e) =>
                    handleChange(index, "correctiveAction", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginTop: "10px",
          gap: "10px",
        }}
      >
        <button onClick={removeRow} style={removeButtonStyle}>
          - Remove
        </button>
        <button onClick={addRow} style={addButtonStyle}>
          + Add More
        </button>
      </div>
    </div>
  );
};

// Styles
const headerCell = {
  border: "1px solid #000",
  padding: "10px",
  textAlign: "center",
  fontWeight: "bold",
  backgroundColor: "#d3c9ce",
  fontSize: "14px",
};

const cell = {
  border: "1px solid #ccc",
  padding: "25px",
  textAlign: "left",
};

const inputStyle = {
  width: "100%",
  padding: "25px",
  borderRadius: "4px",
  border: "1px solid gray",
  fontSize: "14px",
};

const addButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

const removeButtonStyle = {
  backgroundColor: "white",
  border: "1px solid lightgrey",
  color: "grey",
  borderRadius: "4px",
  padding: "8px 12px",
  cursor: "pointer",
};

export default RegulatoryNonComplianceTable;
